import { yupResolver } from '@hookform/resolvers/yup';
import { useAppSelector } from 'app/store';
import { getSongsFolders } from 'app/store/SongList/selectors';
import { useMemo } from 'react';
import { FolderItem } from 'types/song';
import { fieldValidationMessages } from 'app/constants';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';

const getValidationSchema = (notOneOfArray: string[]) =>
  yup.object().shape({
    title: yup
      .string()
      .required(fieldValidationMessages.REQUIRED)
      .max(255, fieldValidationMessages.MAX_CHAR(255))
      .notOneOf(notOneOfArray, 'Song folder with this name already exists'),
  });

export const useSongFolderRenameForm = ({
  folder,
}: {
  folder?: FolderItem;
}) => {
  const folders = useAppSelector(getSongsFolders);
  const notOneOfArray = useMemo(
    () =>
      folders
        .filter(({ title }) => folder?.title !== title)
        .map(({ title }) => title),
    [folders, folder?.title]
  );

  return useForm<{ title: string }>({
    mode: 'all',
    defaultValues: {
      title: folder?.title,
    },
    resolver: yupResolver(getValidationSchema(notOneOfArray)),
  });
};
